import 'css-chunksrc/client/scenes/project/secondaryCriteria/styles.scss';export default {
  "secondaryCriteriaWrapper": "_secondaryCriteriaWrapper_j3w1x_1",
  "specialSection": "_specialSection_j3w1x_6",
  "normalCriteria": "_normalCriteria_j3w1x_12",
  "secondaryCriteria": "_secondaryCriteria_j3w1x_1",
  "sectionTitle": "_sectionTitle_j3w1x_24",
  "row": "_row_j3w1x_39",
  "label": "_label_j3w1x_44",
  "form": "_form_j3w1x_55",
  "required": "_required_j3w1x_63"
};